import { useState, useEffect } from 'react';
import { EventsPage } from '../../pages/EventsPage';
import { EventsScheduleSection } from '../attendee-mobile/EventsScheduleSection';
import { useAuth } from '../../contexts/AuthContext';
import { isAtLeast } from '../../utils/roles';

function useMediaQuery(maxWidth: number): boolean {
  const [matches, setMatches] = useState(() => window.matchMedia(`(max-width: ${maxWidth - 1}px)`).matches);

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${maxWidth - 1}px)`);
    const handler = (e: MediaQueryListEvent) => setMatches(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, [maxWidth]);

  return matches;
}

/**
 * MobileEventsWrapper — On mobile viewports (<768px), attendee/viewer roles see
 * the read-only vertical event tiles experience (EventsScheduleSection). On
 * desktop, everyone gets the full EventsPage.
 *
 * IMPORTANT: operational roles (Customer Editor / Super User and above) ALWAYS
 * get the full EventsPage, even on mobile, because the tiles view has no edit
 * affordances. Previously every role was forced into the read-only tiles on
 * narrow viewports, which meant an organizer on a tablet or a narrow window
 * had no way to edit event metadata at all.
 */
export function MobileEventsWrapper() {
  const isMobile = useMediaQuery(768);
  const { user } = useAuth();
  const canManageEvents = isAtLeast(user?.role ?? '', 'CustomerEditor');

  if (isMobile && !canManageEvents) {
    return <EventsScheduleSection />;
  }

  return <EventsPage />;
}
